module.exports = __webpack_public_path__ + "static/img/logo-new.4f517e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-new.png
// module id = i5Xq
// module chunks = 0